import { render, staticRenderFns } from "./CustomerGroupDetail.vue?vue&type=template&id=07006947&scoped=true&"
import script from "./CustomerGroupDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerGroupDetail.vue?vue&type=style&index=0&id=07006947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07006947",
  null
  
)

export default component.exports